//import libraries
import { Component, OnInit } from '@angular/core';

//import constants
import { AppSettings } from '../../../constants/app-settings';
import { AppPermissions } from '../../../constants/app-permission';
import { AppFrontRoutes } from '../../../constants/app-front-routes';

//import services
import { DashboardService } from '../../../services/dashboard.service';

@Component({
  selector: '[app-dashboard]',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  host: {'id': 'content'},
  providers: [DashboardService]
})
export class DashboardComponent implements OnInit {

  public dateValue: Date = new Date ("05/16/2017");

  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;

  dashboardData
  language;

  constructor(
    private dashboardService : DashboardService
  ) { }

  ngOnInit() {

    this.dashboardService.load_data().subscribe(resp => {
      
      this.language = this.dashboardService.langData(resp);
      this.dashboardData = this.dashboardService.dashboardData(resp);
      console.log("======= Lang Data ======")
      console.log(this.language)
    });

  }

}
